<table mat-table [dataSource]="dataSource" class="full-width-table" matSort>

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="col-id">ID</th>
        <td mat-cell *matCellDef="let element" class="col-id">
            {{element.id}}
        </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="col-name">Name</th>
        <td mat-cell *matCellDef="let element" class="col-name">
            {{element.name}}
        </td>
    </ng-container>

    <ng-container matColumnDef="base">
        <th mat-header-cell *matHeaderCellDef class="col-base">Basis URL</th>
        <td mat-cell *matCellDef="let element" class="col-base">
            {{element.baseUrl}}
        </td>
    </ng-container>

    <ng-container matColumnDef="webTicket">
        <th mat-header-cell *matHeaderCellDef class="col-webTicket">Web Ticket</th>
        <td mat-cell *matCellDef="let element" class="col-webTicket">
            {{element.webTicket}}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="col-actions"> </th>
        <td mat-cell *matCellDef="let element" class="col-actions">
            <button [disabled]="!element.canEdit" (click)="edit(element)" mat-icon-button matTooltip="Bearbeiten"><mat-icon>edit</mat-icon></button>
            <button [disabled]="!element.canDelete" (click)="delete(element)" mat-icon-button matTooltip="Löschen"><mat-icon>delete</mat-icon></button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #paginator [length]="dataSource?.data.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
               [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>
